import { render, staticRenderFns } from "./PhotoButton.vue?vue&type=template&id=9683c102&"
import script from "./PhotoButton.vue?vue&type=script&lang=ts&"
export * from "./PhotoButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports